/* eslint-disable @typescript-eslint/no-explicit-any */
import ImageOptimize from '@/components/ImageOptimize';
import ModuleBanner from '@/components/LandingPageModule/ModuleBanner';
import ModuleBannerL2 from '@/components/LandingPageModule/ModuleBannerL2';
import ModuleProductList from '@/components/LandingPageModule/ModuleProductList';
import ModuleProductTab from '@/components/LandingPageModule/ModuleProductTab';
import ModuleSlider from '@/components/LandingPageModule/ModuleSlider';
import ModuleTabScroll from '@/components/LandingPageModule/ModuleTabScroll';
import ProductCard from '@/components/ProductCard';
import { BLOCK_CMS_TYPE, ProductCardType, PromotionTypes } from '@/constants';
import { Meta } from '@/layouts/Meta';
import { Main } from '@/templates/Main';
import type { BlockCMS } from '@/types';
import { type Product, type Promotion } from '@/types';
import { getTranslate, setContext } from '@/utils/api-interceptors';
import * as pixel from '@/utils/fpixel';

import ModuleProductListFull from '@/components/LandingPageModule/ModuleProductListFull';
import { useNotification } from '@/containers';
import {
  getBannerSSR,
  getBottomMenu,
  getMenus,
  getPromotionDetailSSR,
  getQuickMenu,
  getSaleRegion,
} from '@/utils/endpoint';
import { getCookies } from 'cookies-next';
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const PromotionDetail = ({ promotionDetail }: { promotionDetail: Promotion }) => {
  useEffect(() => {
    pixel.fbqEvent('ViewContent');
  }, []);
  const { systemConfig } = useNotification();
  const qtt = systemConfig?.imageQlt && systemConfig?.imageQlt != '' ? systemConfig?.imageQlt : 80;

  const bgImage =
    promotionDetail?.customization?.desktop?.backgroundImage ||
    promotionDetail?.customization?.backgroundImage ||
    promotionDetail?.backgroundImage;
  const bgColor =
    promotionDetail?.customization?.desktop?.backgroundColor ||
    promotionDetail?.customization?.backgroundColor ||
    promotionDetail?.desktopBackgroundColor;

  const customStyle = {
    backgroundColor: bgColor,
    backgroundImage: bgImage && `url(${bgImage}?format=webp&quality=${qtt})`,
    backgroundRepeat: bgImage && 'no-repeat',
    backgroundPosition: bgImage && 'center center',
    backgroundSize: bgImage && '100% 100%',
  };
  const router = useRouter();
  const renderCMS = (data: BlockCMS, index: number) => {
    switch (data.type) {
      case BLOCK_CMS_TYPE.SLIDER:
        return data && data.data.length > 0 ? <ModuleSlider data={data} key={index} order={index} /> : '';
        break;
      case BLOCK_CMS_TYPE.BANNER_ONE_LINE:
        return data && data.data.length > 0 ? <ModuleBanner data={data} key={index} order={index} /> : '';
        break;
      case BLOCK_CMS_TYPE.BANNER_22:
        return data && data.data.length > 0 ? <ModuleBannerL2 data={data} key={index} order={index} /> : '';
        break;
      case BLOCK_CMS_TYPE.PRODUCT_LIST:
        return data && data.data.length > 0 ? <ModuleProductList data={data} key={index} order={index} /> : '';
        break;
      case BLOCK_CMS_TYPE.PRODUCT_LIST_FULL:
        return data && data.data.length > 0 ? <ModuleProductListFull data={data} key={index} order={index} /> : '';
        break;
      case BLOCK_CMS_TYPE.PRODUCT_TAB:
        return data && data.data.length > 0 ? <ModuleProductTab data={data} key={index} order={index} /> : '';
        break;
      case BLOCK_CMS_TYPE.TAB_SCROLL:
        return data && data.data.length > 0 ? <ModuleTabScroll data={data} key={index} order={index} /> : '';
        break;

      default:
        break;
    }
  };
  {
    if (promotionDetail && promotionDetail?.type == PromotionTypes.CMS_PAGE) {
      return (
        <Main
          style={customStyle}
          className="!pt-0"
          meta={
            <Meta
              title={
                getTranslate(promotionDetail?.metaTitle) && getTranslate(promotionDetail?.metaTitle) !== ''
                  ? getTranslate(promotionDetail?.metaTitle)
                  : getTranslate(promotionDetail?.name)
              }
              description={
                getTranslate(promotionDetail?.metaDescription) && getTranslate(promotionDetail?.metaDescription) !== ''
                  ? getTranslate(promotionDetail?.metaDescription)
                  : getTranslate(promotionDetail?.content)
              }
              noFollow={promotionDetail?.noFollow}
              noIndex={promotionDetail?.noIndex}
              canonical={promotionDetail?.canonicalUrl || process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
              mobileAlternate={{
                media: 'only screen and (max-width:991px))',
                href:
                  process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
                  process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
                  '',
              }}
            />
          }
        >
          <div className="page-cms container flex flex-col px-0">
            {promotionDetail &&
              promotionDetail?.desktopPromotionBlocks.map((item, index) => {
                return renderCMS(item, index);
              })}
          </div>
        </Main>
      );
    } else {
      return (
        <Main
          style={customStyle}
          className="!mt-0"
          meta={
            <Meta
              title={
                getTranslate(promotionDetail?.metaTitle) && getTranslate(promotionDetail?.metaTitle) !== ''
                  ? getTranslate(promotionDetail?.metaTitle)
                  : getTranslate(promotionDetail?.name)
              }
              description={
                getTranslate(promotionDetail?.metaDescription) && getTranslate(promotionDetail?.metaDescription) !== ''
                  ? getTranslate(promotionDetail?.metaDescription)
                  : getTranslate(promotionDetail?.content)
              }
              noFollow={promotionDetail?.noFollow}
              noIndex={promotionDetail?.noIndex}
              canonical={promotionDetail?.canonicalUrl || process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
              mobileAlternate={{
                media: 'only screen and (max-width:991px))',
                href:
                  process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
                  process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
                  '',
              }}
            />
          }
        >
          <section className="promotionPage min-h-[500px] pb-10">
            <div className="promotionBanner pt-8">
              <Link href={promotionDetail?.bannerLink || promotionDetail?.customization?.desktop?.bannerLink || '/'}>
                <ImageOptimize
                  className="rounded"
                  width={1312}
                  height={450}
                  src={
                    promotionDetail?.customization?.desktop?.banner ||
                    promotionDetail?.customization?.banner ||
                    promotionDetail?.desktopBanner ||
                    ''
                  }
                  alt={getTranslate(promotionDetail?.name)}
                  priority={true}
                />
              </Link>
            </div>
            <div className="listProduct mt-8 grid grid-cols-4 gap-4 pb-[80px]">
              {promotionDetail &&
                promotionDetail?.products.map((item: Product, idx: number) => {
                  return (
                    <ProductCard
                      product={item}
                      layout={4}
                      type={ProductCardType.LIST_HOT}
                      className=""
                      key={item._id + idx + 'hd'}
                    />
                  );
                })}
            </div>
          </section>
        </Main>
      );
    }
  }
};

export default PromotionDetail;

export const getServerSideProps: GetServerSideProps = async (context: GetServerSidePropsContext) => {
  const { req, res, query } = context;
  const { token, language, messages } = await setContext(getCookies({ req, res }), {
    language: context.locale,
  });

  const { slug } = query;
  if (!slug) {
    return {
      notFound: true,
    };
  }

  const [menus, regions, banner, quickMenu, promotionDetail, bottomMenu] = await Promise.all([
    getMenus(),
    getSaleRegion(),
    getBannerSSR(),
    getQuickMenu(),
    getPromotionDetailSSR(slug as string),
    getBottomMenu(),
  ]);
  if (!promotionDetail) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      menus,
      regions,
      banner,
      language,
      messages,
      quickMenu,
      bottomMenu,
      promotionDetail,
      token: token || null,
    },
  };
};
